import React from 'react';
import { usePartnerSettings } from '../hooks/use-partner-settings.js';
import PartnerSettingsPageView from './partner-settings-page-view.jsx';

function PartnerSettingsPageContainer() {
  const state = usePartnerSettings();
  return <PartnerSettingsPageView {...state} />;
}

export default PartnerSettingsPageContainer;
